/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import './PanelsStatus.css';
import {APIProvider, Map, AdvancedMarker, useMap, InfoWindow} from '@vis.gl/react-google-maps';
import { AuthContext } from '../../../contexts/authContext';
import {MarkerClusterer} from '@googlemaps/markerclusterer';
import config from '../../../config';
import axios from 'axios';
import panelOk from '../../../assets/svgs/0.svg'
import panelWarn from '../../../assets/svgs/1.svg'
import panelErr from '../../../assets/svgs/2.svg'
import panelNotFoundInLogs from '../../../assets/svgs/3.svg';
import panelNotFoundForLog from '../../../assets/svgs/4.svg';
import {getFormatDateTimeMillisecondsItFormat} from '../../../utils/CommonUtilities';
import CircleProgress from '../../../components/CircleProgress/CircleProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Chip from '@mui/material/Chip';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PanelsStatusTable from './PanelsStatusTable';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import panelBroken from '../../../assets/svgs/9.svg'
import palinaOk from '../../../assets/svgs/0p.svg'
import palinaWarn from '../../../assets/svgs/1p.svg'
import palinaErr from '../../../assets/svgs/2p.svg'
import palinaNotFoundInLogs from '../../../assets/svgs/3p.svg';
import palinaNotFoundForLog from '../../../assets/svgs/4p.svg';
import palinaBroken from '../../../assets/svgs/9p.svg';
import useNotification from '../../../hooks/useNotification';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SquareLog = (props) => {
    
    return (
        <div className='log-detail'>
            <div className={`block block-${props?.el?.severity}`}></div>
            <div>{(props.el.lastUpdateDate === 'N/A' || !props.el?.lastUpdateDate) ? 'N/A' : getFormatDateTimeMillisecondsItFormat(props.el.lastUpdateDate)}</div>
            <div>{`${props.el?.source ? props.el.source : 'status'}${props.el?.lang ? ' - ' + props.el?.lang : ''}`}</div>
        </div>
    )
}

const getPanelFileStatus = (stat) => {
    switch (stat) {
        case "Y":
            return "Attivo";
        case "N":
            return "Non Attivo"
        case "G":
            return "Guasto"
        default:
            return "Non in servizio";
    }
}

const createBlocksLineStructure = (fullLogsStructure, logsSeverity, logsUpdateDates, statusObj) => {
    let copyFullLogsStructure = fullLogsStructure.map(({...el}) => {
        delete el.counter;
        if(typeof logsSeverity !== 'number'){
            let matchLogsSeverity = logsSeverity.find(elSeverity => elSeverity.source === 'splashscreen' ? elSeverity.source === el.source : (elSeverity.source === el.source && elSeverity.language === el.lang));
            if(matchLogsSeverity){
                el.severity = matchLogsSeverity?.severity
            }else{
                el.severity = 3
            }
            let matchLogsUpdateDate = logsUpdateDates.find(elUpdateDate => elUpdateDate.source === 'splashscreen' ? elUpdateDate.source === el.source : (elUpdateDate.source === el.source && elUpdateDate.language === el.lang));
            if(matchLogsUpdateDate){
                el.lastUpdateDate = matchLogsUpdateDate.dateTime
            }else{
                el.lastUpdateDate = 'N/A'
            }
        }else{
            el.severity = 3;
            el.lastUpdateDate = 'N/A'
        }

        return el;
    });
    copyFullLogsStructure.push({...statusObj})
    return copyFullLogsStructure;
}

const PinMaker = (props) => {
    const map = useMap();
    const [markers, setMarkers] = useState({});
    const [infoToOpen, setInfoToOpen] = useState(false);
    const clusterer = useRef(null);
    
    useEffect(() => {
        if (!map) return;
        if (!clusterer.current) {
            clusterer.current = new MarkerClusterer({map});
        }
    }, [map]);
    
    useEffect(() => {
        clusterer.current?.clearMarkers();
        clusterer.current?.addMarkers(Object.values(markers));
    }, [markers]);

    const setMarkerRef = (marker, key) => {
        if (marker && markers[key]) return;
        if (!marker && !markers[key]) return;

        setMarkers(prev => {
        if (marker) {
            return {...prev, [key]: marker};
        } else {
            const newMarkers = {...prev};
            delete newMarkers[key];
            return newMarkers;
        }
        });
    };

    const handleClick = useCallback((ev, key) => {
        if(!map) return;
        if(!ev.latLng) return;
        setInfoToOpen(key);
        map.panTo(ev.latLng);
    }, []);

    const handleClose = useCallback((key) => 
        setInfoToOpen(false)
    , []);

    const matchingImage = (severity, tipologia, panelStatus) => {
        let result = undefined;
        if(props.roleUser === "MU"){
            if(panelStatus === 'Y'){
                if(tipologia === 'T'){
                    result = panelOk;
                }else{
                    result = palinaOk;
                }
            }else{
                if(tipologia === 'T'){
                    result = panelBroken;
                }else{
                    result = palinaBroken;
                }
            }
            return result
        }


        if(tipologia === 'T'){
            switch (severity) {
            case 0:
                result = panelOk;
                break;
            case 1:
                result = panelWarn;
                break;
            case 2:
                result = panelErr;
                break;
            case 3:
                result = panelNotFoundInLogs;
                break;
            case 9:
                result = panelBroken;
                break;
            default:
                result = panelNotFoundForLog;
                break;
        }
        }else{
            switch (severity) {
            case 0:
                result = palinaOk;
                break;
            case 1:
                result = palinaWarn;
                break;
            case 2:
                result = palinaErr;
                break;
            case 3:
                result = palinaNotFoundInLogs;
                break;
            case 9:
                result = palinaBroken;
                break;
            default:
                result = palinaNotFoundForLog;
                break;
            }
        }
        return result;
    }

    return (
        <>
            {props.markers.filter(el => {
                if(props.autocompleteFilter.length>0){
                    return props.autocompleteFilter.some(item => item.id === el.idEntita)
                }else{
                    return el
                }}).filter(el => ((el.panelStatus === 'Y' || el.panelStatus === 'G') && (props.tipologiaFilter === 'A' ? true : el.tipologia === props.tipologiaFilter))).map( (panel) => {
                    
                    let arrOfBlocks = createBlocksLineStructure(props.logsSources, panel?.logs?.severity || 3, panel?.logs?.lastUpdateDate, panel.status);

                    //severityColor = panel.panelMapColor colore pannello
                    let severityColor = panel.operativityLevel === 0 ? 0 : panel.operativityLevel === 2 ? 2 : panel.operativityLevel === 3 ? 3 : null//operativity
                    
                    if(panel.panelStatus === 'G'){
                        //blocco temporaneamente rimosso per revert della modifica
                        {/* let arrDatetimesLogs = panel.logs.lastUpdateDate.map(el => el?.dateTime );
                        let arrDatetimesStatuses = panel.status?.lastUpdateDate || undefined;
                        
                        if(!(arrDatetimesLogs.some(i => Boolean(i)) || arrDatetimesStatuses)){ */}
                            severityColor = 9
                        //}
                    }
                    if(typeof props.filterPanels === 'number' && props.filterPanels !== severityColor){
                        return <></>;
                    }
                    if(props.filterPanelPerStatus){
                        if(props.filterPanelPerStatus !== panel.panelStatus){
                            return <></>;
                        }
                    }
                    let imgToRender = matchingImage(severityColor, panel.tipologia, panel.panelStatus);
                    return (<AdvancedMarker
                        key={panel.key}
                        position={panel.location}
                        ref={marker => setMarkerRef(marker, panel.key)}
                        clickable={true}
                        onClick={(event) => handleClick(event, panel.key)}
                    >

                        {(panel.key === infoToOpen )&& (
                            <InfoWindow className='info-window' anchor={markers[panel.key]} onClose={(event) => handleClose(panel.key)} headerContent={<div className='panel-title'>{panel.key}</div>}>
                                {props.roleUser!=='MU' ? (<div className='logs-wrapper'>
                                    <div className='logs-box'>
                                        {arrOfBlocks.map(el => <SquareLog {...{el}}/>)}
                                    </div>
                                    {(panel.status?.severity<3)&&(
                                        <div className='status-box'>
                                            {panel.status.status}
                                        </div>
                                    )}
                                </div>)
                                : <span>{getPanelFileStatus(panel.panelStatus)}</span>
                                }
                            </InfoWindow>
                        )}
                        <img src={imgToRender} alt={severityColor.toString()} width={25} height={48}></img>
                    </AdvancedMarker>)
            })}
        </>
    );
};

function PanelsStatus(props) {
    const auth = useContext(AuthContext);
    const { notificationError } = useNotification();
    const [monitoringData, setMonitoringData] = useState([]);
    const [logsSourcesPerLanguage, setLogsSourcesPerLanguage] = useState([]);
    
    const [loading, setLoading] = useState(true);

    const [filterPanelsInput, setFilterPanelsInput] = useState('');

    const [filterPanels, setFilterPanels] = useState(null);
    const [autocompleteFilter, setAutocompleteFilter] = useState([]);
    const [optionsAutocomplete, setOptionsAutocomplete] = useState([]);
    const [tipologiaFilter, setTipologiaFilter] = useState('T');
    
    const [filterPanelPerStatus, setFilterPanelPerStatus] = useState(null);

    const [switchMap, setSwitchMap] = useState(false);

    useEffect(() => {
        async function init(){
            if(props.roleUser === 'MU'){
                setSwitchMap(true);
                setFilterPanelPerStatus(localStorage.getItem('statusPanelAlter') || null);
            }else{
                setFilterPanels(parseInt(localStorage.getItem('statusPanel')) || null);
            }
            setTipologiaFilter(localStorage.getItem('tipologiaRadio') || 'T');

            setAutocompleteFilter(JSON.parse(localStorage.getItem('impiantiList')) || [])
            await getLogsForMapStatus();
        }
        init();
    }, [])

    useEffect(() => {
        if(!loading){
            getLogsForMapStatus()
        }
    }, [props.city])

    useEffect(() => {
        if(monitoringData.length)setLoading(false)
    },[filterPanels, autocompleteFilter, tipologiaFilter, filterPanelPerStatus])

    const getLogsForMapStatus = async () => {
        try {
            setLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-logs-for-map-status',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };
            const response = await axios(axiosParams);
            let tempArrData = response.data[0].panels;
            let result = buildPanelsObjects(tempArrData);
            //blocco da rimuovere una volta rilasciate tutte le rotte compresa la status
            let logsToHold = response.data[4].logsSourcesPerLanguages.map(el => el.source !== 'ticker' ? el : false ).filter(el => el)
            setLogsSourcesPerLanguage(logsToHold);
            let optionsForAutocomplete = getOptions(result);
            setOptionsAutocomplete(optionsForAutocomplete);
            MapResultCell(result);
            setMonitoringData(result);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const MapResultCell = (arr) => {
        for (let index = 0; index < arr.length; index++) {
            let severityResult = undefined;
            let severityStatusResult = undefined
            const elementObj = arr[index];

            if(typeof elementObj?.logs?.severity === 'number'){
                severityResult = elementObj?.logs?.severity;
            }else{
                let severityColor = 3;
                for (let index = 0; index < elementObj?.logs?.severity.length; index++) {
                    const element = elementObj?.logs?.severity[index];
                    if(element.severity < severityColor)severityColor = element.severity;
                    //questo blocco è da rimuovere una volta ridefinite le regole dei colori
                    //per ora su richiesta di mauro se trovo un verde, il pannello è vivo


                    //if(element.severity > severityColor)severityColor = element.severity;
                }
                severityResult = severityColor;
            }
            //da aggiungere status come controllo siccome ora è omesso
            if(typeof elementObj?.status?.severity === 'number'){
                severityStatusResult = elementObj?.status?.severity;
            }else{
                let severityColor = 3;
                for (let index = 0; index < elementObj?.status?.severity.length; index++) {
                    const element = elementObj?.status?.severity[index];
                    if(element.severity < severityColor)severityColor = element.severity;
                    //questo blocco è da rimuovere una volta ridefinite le regole dei colori
                    //per ora su richiesta di mauro se trovo un verde, il pannello è vivo


                    //if(element.severity > severityColor)severityColor = element.severity;
                }
                severityStatusResult = severityColor;
            }

            if(severityResult>severityStatusResult){
                severityResult = severityStatusResult
            }
        
            elementObj.panelMapColor = severityResult;
        
        }
    }

    const getOptions = (data) => {
        let optionsArr = [];
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if(element.panelStatus === 'N' || element.panelStatus === 'NS')continue;
            
            let obj = {
                id: element.idEntita,
                label: element.key
            }
            optionsArr.push(obj);
        }
        
        return optionsArr;
    }

    const buildPanelsObjects = (data) => {
        let arrOfLocations = [];
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let objMarker = {key: element.nome + ' - ' + element.idEntita + ' (' + element.idFermata + ')', location: { lat: parseFloat(element.lat), lng: parseFloat(element.lon) }, ...element}
            arrOfLocations.push(objMarker);
        }
        return arrOfLocations;
    }

    return (
        <div className='component-container status-panels'>
            {(switchMap && loading) && <CircleProgress isDialog={true}/>}
            <div className='component-card'>
                <div className='filters'>
                    <div className='map-filters'>
                        <FormControl sx={{'maxWidth': '75px', 'height': '80px', 'minWidth': '75px'}} variant='standard'>
                            <InputLabel id="select-label">{filterPanels?.toString() || filterPanelPerStatus ? '' : 'Status'}</InputLabel>
                            <Select
                                labelId="select-label"
                                id="select"
                                value={props.roleUser !== "MU" ? filterPanels : filterPanelPerStatus}
                                label="Status"
                                onChange={(event) => {
                                    setLoading(true);
                                    if(props.roleUser !== "MU"){
                                        setFilterPanels(event.target.value);
                                        localStorage.setItem('statusPanel', event.target.value);
                                    }else{
                                        setFilterPanelPerStatus(event.target.value);
                                        localStorage.setItem('statusPanelAlter', event.target.value);
                                    }
                                }}
                            >
                                {props.roleUser !== 'MU' ? 
                                        [
                                            <MenuItem value={null}>Tutti</MenuItem>,
                                            <MenuItem value={0}><img src={panelOk} alt={'Ok'} width={25} height={48}></img></MenuItem>,
                                            <MenuItem value={2}><img src={panelErr} alt={'Warning'} width={25} height={48}></img></MenuItem>,
                                            <MenuItem value={3}><img src={panelNotFoundInLogs} alt={'Error'} width={25} height={48}></img></MenuItem>,
                                            <MenuItem value={9}><img src={panelBroken} alt={'Guasto'} width={25} height={48}></img></MenuItem>
                                        ]
                                    :
                                        [
                                            <MenuItem value={null}>Tutti</MenuItem>,
                                            <MenuItem value={'Y'}><img src={panelOk} alt={'Ok'} width={25} height={48}></img></MenuItem>,
                                            <MenuItem value={'G'}><img src={panelBroken} alt={'Guasto'} width={25} height={48}></img></MenuItem>
                                        ]
                                }
                            </Select>
                        </FormControl>
                        <FormControl sx={{minWidth: "265px"}}>
                            <FormLabel id="tipologia-radio-buttons-group">Tipologia</FormLabel>
                            <RadioGroup
                                aria-labelledby="tipologia-radio-buttons-group"
                                name="tipologia-controlled-radio-buttons-group"
                                value={tipologiaFilter}
                                fullWidth
                                onChange={(event) => {
                                    setLoading(true);
                                    setTipologiaFilter(event.target.value);
                                    localStorage.setItem('tipologiaRadio', event.target.value)
                                }}
                                row
                            >
                                <FormControlLabel value="T" control={<Radio />} label="Totem" />
                                <FormControlLabel value="P" control={<Radio />} label="Paline" />
                                <FormControlLabel value="A" control={<Radio />} label="Tutti" />
                            </RadioGroup>
                        </FormControl>
                        {switchMap&&(
                            <Autocomplete
                                multiple
                                id="checkboxes-tags"
                                options={optionsAutocomplete}
                                disableCloseOnSelect
                                limitTags={2}
                                value={autocompleteFilter}
                                onChange={(event, newValue) => {
                                    setAutocompleteFilter(newValue);
                                    setLoading(true);
                                    localStorage.setItem('impiantiList', JSON.stringify(newValue))
                                }}
                                renderOption={(props, option, { selected }) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                        />
                                        {option.label}
                                    </li>
                                    );
                                }}
                                renderTags={(value, getTagProps) => {
                                    const numTags = value.length;
                                    const limitTags = 2;

                                    return (
                                        <>
                                            {value.slice(0, limitTags).map((option, index) => (
                                                <Chip
                                                    {...getTagProps({ index })}
                                                    key={index}
                                                    label={option.label}
                                                />
                                            ))}

                                            {numTags > limitTags && ` +${numTags - limitTags}`}
                                        </>
                                    );
                                }}
                                inputValue={filterPanelsInput}
                                //style={{ width: '100%' }}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField {...params} label="Assets" placeholder="" onChange={(event) => setFilterPanelsInput(event.target.value)}/>
                                )}
                                noOptionsText="Nessun elemento"
                            />
                        )}
                    </div>
                    {props.roleUser !== "MU" && (<FormGroup>
                        <FormControlLabel control={<Switch onChange={(event) => setSwitchMap(event.target.checked)} checked={switchMap}/>} label="Mappa" />
                    </FormGroup>)}  
                </div>
                {switchMap ?
                    <APIProvider apiKey={config.GOOGLE_MAPS_API}>
                    {/* map popup per quando è pronta in callback?*/} 
                        {!loading&&(<Map
                            defaultZoom={config.DEFAULT_MAP_ZOOM}
                            defaultCenter={config.MAP_COORDS[props.city]}
                            mapId='PanelsStatusMap'
                            onCameraChanged={ (ev) =>
                                {return} //console.log('camera changed:', ev.detail.center, 'zoom:', ev.detail.zoom)
                            }
                            //streetViewControl={false}
                        >
                            <PinMaker markers={monitoringData} logsSources={logsSourcesPerLanguage} filterPanels={filterPanels} autocompleteFilter={autocompleteFilter} tipologiaFilter={tipologiaFilter} filterPanelPerStatus={filterPanelPerStatus} roleUser={props.roleUser}/>
                        </Map>)}
                    </APIProvider>
                    :
                    <PanelsStatusTable getMonitoringData={getLogsForMapStatus} monitorData={monitoringData.filter(el => (el.panelStatus === 'Y' || el.panelStatus === 'G'))} loading={loading} SquareLog={SquareLog} getPanelFileStatus={getPanelFileStatus} createBlocksLineStructure={createBlocksLineStructure} logsSources={logsSourcesPerLanguage} roleUser={props.roleUser} filterPanelsOperativity={filterPanels} tipologiaFilter={tipologiaFilter} logOut={props.logOut}/>
                }
            </div>
        </div>
    )
}

export default PanelsStatus